module.exports = __webpack_public_path__ + "struggle.32d7fcd3.png";